export default __webpack_public_path__ + "static/media/miguel-lopes-9.565db3e9.jpg";